import React from 'react'
import { Badge } from 'transfix-ui/components/Badge'
import { Typography, makeStyles, Skeleton } from 'transfix-ui/core'
import { TRACKING_BADGE_COLORS, TRACKING_LABELS } from '../../constants'
import { ITrackingType } from '../../types'

export interface ILoadCountProps {
  /**
   * @default false
   */
  loading?: boolean
  trackingType: ITrackingType
  count: number
}

const useLoadCountStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  badge: {
    minWidth: '29px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  badgeSkeleton: {
    width: '29px',
    height: '27px',
  },
}))

const LoadCount = ({ count, loading = false, trackingType }: ILoadCountProps) => {
  const styles = useLoadCountStyles()

  const label = TRACKING_LABELS[trackingType]
  const badgeColor = TRACKING_BADGE_COLORS[trackingType]

  return (
    <div className={styles.container}>
      <Typography variant='body2'>{label}</Typography>
      {loading ? (
        <Skeleton variant='rectangular' className={styles.badgeSkeleton} />
      ) : (
        <Badge size='medium' color={badgeColor} label={String(count)} className={styles.badge} />
      )}
    </div>
  )
}

export default LoadCount
